import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "thickness", "speed", "emptyColor", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// ../../../react-shim.js
import React from "react";

// src/spinner.tsx
import { chakra, forwardRef, keyframes, omitThemingProps, useStyleConfig } from "@chakra-ui/system";

// ../../utilities/shared-utils/src/index.ts
var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(Boolean).join(" ");
};

// src/spinner.tsx
var spin = keyframes({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});
var Spinner = forwardRef(function (props, ref) {
  var styles = useStyleConfig("Spinner", props);
  var _omitThemingProps = omitThemingProps(props),
    _omitThemingProps$lab = _omitThemingProps.label,
    label = _omitThemingProps$lab === void 0 ? "Loading..." : _omitThemingProps$lab,
    _omitThemingProps$thi = _omitThemingProps.thickness,
    thickness = _omitThemingProps$thi === void 0 ? "2px" : _omitThemingProps$thi,
    _omitThemingProps$spe = _omitThemingProps.speed,
    speed = _omitThemingProps$spe === void 0 ? "0.45s" : _omitThemingProps$spe,
    _omitThemingProps$emp = _omitThemingProps.emptyColor,
    emptyColor = _omitThemingProps$emp === void 0 ? "transparent" : _omitThemingProps$emp,
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var _className = cx("chakra-spinner", className);
  var spinnerStyles = _objectSpread({
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: thickness,
    borderBottomColor: emptyColor,
    borderLeftColor: emptyColor,
    animation: "".concat(spin, " ").concat(speed, " linear infinite")
  }, styles);
  return /* @__PURE__ */React.createElement(chakra.div, _objectSpread({
    ref: ref,
    __css: spinnerStyles,
    className: _className
  }, rest), label && /* @__PURE__ */React.createElement(chakra.span, {
    srOnly: true
  }, label));
});
Spinner.displayName = "Spinner";
export { Spinner };